var map = {
	"./menu.json": 56505,
	"./partners.json": 75401,
	"./service_services.json": 35834,
	"./service_work.json": 66999,
	"./services.json": 85498,
	"./servives.json": 82805,
	"./users.json": 15158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52932;